import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { setTheme } from "../../helpers";
import { GoDotFill } from "react-icons/go";

const Header = ({ setAppear }) => {
  const [color, setColor] = useState(false);
  const [show, setShow] = useState(false);
  const wrapperRef = useRef(null);
  const location = useLocation();
  const path = [
    { name: "home", to: "/home" },
    { name: "about", to: "/about" },
    { name: "projects", to: "/projects" },
    { name: "contact", to: "/contact" },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShow(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  useEffect(() => {
    let x = JSON.parse(localStorage.getItem("themeCurrent")) ?? true;
    setColor(x);
    setTheme(x);
  }, []);

  return (
    <header className="flex justify-between items-center bg-header py-3 px-6 lg:pl-20 lg:pr-6 fixed top-0 left-0 right-0 z-[999]">
      <Link to={"/home"}>
        <div bis_skin_checked="1">
          <svg
            width="220"
            height="40"
            viewBox="0 0 369.65517241379314 68.96551724137932"
            className="looka-1j8o68f"
          >
            <defs id="SvgjsDefs1390"></defs>
            <g
              fill="var(--bg-btn)"
              id="SvgjsG1391"
              featurekey="Df7oLJ-0"
              transform="matrix(0.8620689655172414,0,0,0.8620689655172414,-12.931034482758621,-8.620689655172415)"
            >
              <path
                xmlns="http://www.w3.org/2000/svg"
                d="M50,10L15,30v40l35,20l34.99-19.994L85,69.99V30L50,10z M50,17.699L74.89,31.92l-6.732,3.848L50,25.397L31.846,35.771  l-6.738-3.851L50,17.699z M64.795,41.546v13.059L53.369,48.08V35.02L64.795,41.546z M46.631,35.02v13.057l-11.423,6.527V41.546  L46.631,35.02z M46.631,80.377L21.735,66.152v-28.46l6.734,3.848v20.761L46.631,72.68V80.377z M38.571,60.377l11.426-6.529  l11.429,6.529L50,66.904L38.571,60.377z M78.265,66.152L53.369,80.377V72.68L71.53,62.305V41.54l6.734-3.848V66.152z"
              ></path>
            </g>
            <g
              id="SvgjsG1392"
              featurekey="Ua4uQk-0"
              transform="matrix(2.0965197215989333,0,0,2.0965197215989333,79.8322780823746,7.4208816704064)"
              fill="var(--text-primary)"
            >
              <path d="M8.72 17.52 l-4.5 0 l-0.88 2.48 l-3.26 0 l4.9 -12.24 l3 0 l4.9 12.24 l-3.28 0 z M5.2 14.74 l2.54 0 l-1.26 -3.56 z M16.96 15 l0 5 l-3 0 l0 -14 l3 0 l0 4.92 c0.7 -0.74 1.58 -1.02 2.58 -1.02 c2.84 0 4.62 2.44 4.62 5.1 l0 5 l-3 0 l0 -5 c0 -1.36 -0.54 -2.32 -2 -2.32 c-1.44 0 -2.2 0.92 -2.2 2.32 z M42 14.6 l0 5.4 l-3 0 l0 -5.4 c0 -1.14 -0.54 -1.92 -1.74 -1.92 c-1.18 0 -1.76 0.8 -1.76 1.92 l0 5.4 l-3 0 l0 -5.4 c0 -1.14 -0.58 -1.92 -1.78 -1.92 c-1.18 0 -1.72 0.8 -1.72 1.92 l0 5.4 l-3 0 l0 -5.4 c0 -2.9 1.98 -4.7 4.76 -4.7 c1.42 0 2.52 0.66 3.24 1.88 c0.72 -1.22 1.82 -1.88 3.24 -1.88 c2.88 0 4.76 1.9 4.76 4.7 z M50.86 15 c-0.08 -1.46 -0.74 -2.32 -2.26 -2.32 c-0.42 0 -0.78 0.06 -1.08 0.18 c-0.92 0.42 -1.26 1.2 -1.26 2.16 c0 0.32 0.04 0.62 0.14 0.88 c0.3 1.04 1.2 1.42 2.2 1.42 c1.52 0 2.26 -0.82 2.26 -2.32 z M54.660000000000004 20 l-3 0 c-0.2 -0.5 -0.38 -1 -0.5 -1.52 c-0.68 1.12 -1.72 1.62 -3 1.62 c-2.86 0 -4.9 -2.4 -4.9 -5.14 c0 -3.16 2.36 -5.06 5.34 -5.06 c3.18 0 5.18 2.04 5.26 5.1 c0.02 0.26 0.02 0.56 0.02 0.92 c0 1.4 0.22 2.8 0.78 4.08 z M62.879999999999995 15 c0 -1.5 -0.74 -2.32 -2.26 -2.32 c-0.42 0 -0.78 0.06 -1.08 0.18 c-0.56 0.26 -0.94 0.64 -1.12 1.24 c-0.1 0.28 -0.14 0.58 -0.14 0.9 s0.04 0.62 0.14 0.9 c0.16 0.58 0.58 1 1.12 1.22 c0.3 0.14 0.66 0.2 1.08 0.2 c1.52 0 2.26 -0.82 2.26 -2.32 z M62.879999999999995 11 l0 -5 l3 0 l0 9 c0 3.18 -2.26 5.1 -5.28 5.1 c-3.08 0 -5.32 -2 -5.32 -5.06 c0 -2.82 2.08 -5.14 4.92 -5.14 c1.06 0 1.98 0.3 2.68 1.1 z M72.42 7.76 l3 0 l0 5.74 l3.94 -5.74 l3.72 0 l-4.28 6.12 l4.44 6.12 l-3.68 0 l-4.14 -5.76 l0 5.76 l-3 0 l0 -12.24 z M90.96 15 c-0.08 -1.46 -0.74 -2.32 -2.26 -2.32 c-0.42 0 -0.78 0.06 -1.08 0.18 c-0.92 0.42 -1.26 1.2 -1.26 2.16 c0 0.32 0.04 0.62 0.14 0.88 c0.3 1.04 1.2 1.42 2.2 1.42 c1.52 0 2.26 -0.82 2.26 -2.32 z M94.75999999999999 20 l-3 0 c-0.2 -0.5 -0.38 -1 -0.5 -1.52 c-0.68 1.12 -1.72 1.62 -3 1.62 c-2.86 0 -4.9 -2.4 -4.9 -5.14 c0 -3.16 2.36 -5.06 5.34 -5.06 c3.18 0 5.18 2.04 5.26 5.1 c0.02 0.26 0.02 0.56 0.02 0.92 c0 1.4 0.22 2.8 0.78 4.08 z M95.86 6 l3 0 l0 14 l-3 0 l0 -14 z M103.66 13.8 c0.3 0.1 0.64 0.18 1 0.22 c0.36 0.06 0.7 0.08 1.02 0.08 c0.4 0 1.42 -0.08 1.42 -0.66 c0 -0.62 -0.88 -0.64 -1.32 -0.64 c-0.88 0 -1.64 0.2 -2.12 1 z M109.32 16.88 l0 2.8 c-1.12 0.26 -2.24 0.44 -3.4 0.44 c-3.18 0 -5.54 -1.86 -5.54 -5.08 c0 -3.18 2.28 -5.14 5.3 -5.14 c2.06 0 4.44 0.98 4.44 3.32 c0 2.32 -2.52 3.18 -4.46 3.18 c-0.74 0 -1.48 -0.2 -2.16 -0.48 c0.4 1.12 1.6 1.3 2.64 1.3 c0.54 0 1.08 -0.02 1.62 -0.1 c0.5 -0.04 1.08 -0.1 1.56 -0.24 z M114.3 13.8 c0.3 0.1 0.64 0.18 1 0.22 c0.36 0.06 0.7 0.08 1.02 0.08 c0.4 0 1.42 -0.08 1.42 -0.66 c0 -0.62 -0.88 -0.64 -1.32 -0.64 c-0.88 0 -1.64 0.2 -2.12 1 z M119.96 16.88 l0 2.8 c-1.12 0.26 -2.24 0.44 -3.4 0.44 c-3.18 0 -5.54 -1.86 -5.54 -5.08 c0 -3.18 2.28 -5.14 5.3 -5.14 c2.06 0 4.44 0.98 4.44 3.32 c0 2.32 -2.52 3.18 -4.46 3.18 c-0.74 0 -1.48 -0.2 -2.16 -0.48 c0.4 1.12 1.6 1.3 2.64 1.3 c0.54 0 1.08 -0.02 1.62 -0.1 c0.5 -0.04 1.08 -0.1 1.56 -0.24 z M138.24 14.6 l0 5.4 l-3 0 l0 -5.4 c0 -1.14 -0.54 -1.92 -1.74 -1.92 c-1.18 0 -1.76 0.8 -1.76 1.92 l0 5.4 l-3 0 l0 -5.4 c0 -1.14 -0.58 -1.92 -1.78 -1.92 c-1.18 0 -1.72 0.8 -1.72 1.92 l0 5.4 l-3 0 l0 -5.4 c0 -2.9 1.98 -4.7 4.76 -4.7 c1.42 0 2.52 0.66 3.24 1.88 c0.72 -1.22 1.82 -1.88 3.24 -1.88 c2.88 0 4.76 1.9 4.76 4.7 z"></path>
            </g>
          </svg>
        </div>
      </Link>

      <div className="flex justify-center items-center">
        <button
          onClick={() => setAppear(true)}
          className="flex sm:hidden pr-3 pl-2 text-green-600 justify-center items-center gap-x-1"
        >
          <div className="animate-ping animate-duration-400">
            <GoDotFill size={10} />
          </div>
        </button>
        <div ref={wrapperRef}>
          <div onClick={() => setShow(!show)} className="sm:hidden">
            {show ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="var(--text-primary)"
                className="w-8 h-8"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18 18 6M6 6l12 12"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="white"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="var(--text-primary)"
                class="w-8 h-8"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                />
              </svg>
            )}
          </div>
          <div
            className={`absolute top-12 right-8 py-2 ${
              show ? "flex" : "hidden"
            } sm:hidden flex-col rounded-2xl shadow-lg bg-body w-[176px] capitalize border border-gray-500 animate-fade-down animate-once animate-duration-500 animate-delay-0 animate-ease-in-out animate-normal animate-fill-both`}
          >
            {path.map((p) => {
              return (
                <Link
                  to={p.to}
                  onClick={() => setShow(false)}
                  className={`transition-all btn-text duration-500 px-2 py-2 font-[600] rounded-xl text-center ease-in-out ${
                    location?.pathname?.includes(p?.to)
                      ? "btn-text"
                      : "text-primary"
                  }`}
                >
                  {p.name}
                </Link>
              );
            })}
            <div className="flex justify-center items-center px-2 py-2 gap-5 rounded-[6px]">
              <svg
                onClick={() => {
                  setColor(true);
                  setTheme(true);
                  localStorage.setItem("themeCurrent", true);
                }}
                width="19"
                height="19"
                xmlns="http://www.w3.org/2000/svg"
                className={`cursor-pointer ${!color && "opacity-60"}`}
              >
                <path
                  d="M9.167 15.833a.833.833 0 0 1 .833.834v.833a.833.833 0 0 1-1.667 0v-.833a.833.833 0 0 1 .834-.834ZM3.75 13.75a.833.833 0 0 1 .59 1.422l-1.25 1.25a.833.833 0 0 1-1.18-1.178l1.25-1.25a.833.833 0 0 1 .59-.244Zm10.833 0c.221 0 .433.088.59.244l1.25 1.25a.833.833 0 0 1-1.179 1.178l-1.25-1.25a.833.833 0 0 1 .59-1.422ZM9.167 5a4.167 4.167 0 1 1 0 8.334 4.167 4.167 0 0 1 0-8.334Zm-7.5 3.333a.833.833 0 0 1 0 1.667H.833a.833.833 0 1 1 0-1.667h.834Zm15.833 0a.833.833 0 0 1 0 1.667h-.833a.833.833 0 0 1 0-1.667h.833Zm-1.667-6.666a.833.833 0 0 1 .59 1.422l-1.25 1.25a.833.833 0 1 1-1.179-1.178l1.25-1.25a.833.833 0 0 1 .59-.244Zm-13.333 0c.221 0 .433.088.59.244l1.25 1.25a.833.833 0 0 1-1.18 1.178L1.91 3.09a.833.833 0 0 1 .59-1.422ZM9.167 0A.833.833 0 0 1 10 .833v.834a.833.833 0 1 1-1.667 0V.833A.833.833 0 0 1 9.167 0Z"
                  fill="var(--text-primary)"
                />
              </svg>
              <label className="inline-flex items-center cursor-pointer">
                <input
                  onClick={(e) => {
                    setColor(!color);
                    setTheme(!e.target.checked);
                    localStorage.setItem("themeCurrent", !color);
                  }}
                  checked={!color}
                  type="checkbox"
                  className="sr-only peer"
                />
                <div className="relative w-11 h-6 bg-btn focus:outline-none focus:border-0 peer-focus:outline-none peer-focus:ring-4 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-tab"></div>
              </label>
              <svg
                onClick={() => {
                  setColor(false);
                  setTheme(false);
                  localStorage.setItem("themeCurrent", false);
                }}
                width="16"
                height="16"
                xmlns="http://www.w3.org/2000/svg"
                className={`cursor-pointer ${color && "opacity-60"}`}
              >
                <path
                  d="M6.474.682c.434-.11.718.406.481.78A6.067 6.067 0 0 0 6.01 4.72c0 3.418 2.827 6.187 6.314 6.187.89.002 1.77-.182 2.584-.54.408-.18.894.165.724.57-1.16 2.775-3.944 4.73-7.194 4.73-4.292 0-7.771-3.41-7.771-7.615 0-3.541 2.466-6.518 5.807-7.37Zm8.433.07c.442-.294.969.232.674.674l-.525.787a1.943 1.943 0 0 0 0 2.157l.525.788c.295.441-.232.968-.674.673l-.787-.525a1.943 1.943 0 0 0-2.157 0l-.786.525c-.442.295-.97-.232-.675-.673l.525-.788a1.943 1.943 0 0 0 0-2.157l-.525-.787c-.295-.442.232-.968.674-.673l.787.525a1.943 1.943 0 0 0 2.157 0Z"
                  fill="var(--text-primary)"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div className="sm:flex justify-center items-center gap-10 text-sm mr-10 font-[700] uppercase hidden">
        {path.map((p) => {
          return (
            <Link
              to={p.to}
              className={`text-hover transition-all duration-200 ease-in-out ${
                location?.pathname?.includes(p?.to)
                  ? "text-secondary"
                  : "text-header"
              }`}
            >
              {p.name}
            </Link>
          );
        })}
        <div className="flex justify-center items-center">
          <div className="flex justify-center items-center w-[251px] h-[48px] gap-5 rounded-[6px]">
            <svg
              onClick={() => {
                setColor(true);
                setTheme(true);
                localStorage.setItem("themeCurrent", true);
              }}
              width="19"
              height="19"
              xmlns="http://www.w3.org/2000/svg"
              className={`cursor-pointer ${!color && "opacity-60"}`}
            >
              <path
                d="M9.167 15.833a.833.833 0 0 1 .833.834v.833a.833.833 0 0 1-1.667 0v-.833a.833.833 0 0 1 .834-.834ZM3.75 13.75a.833.833 0 0 1 .59 1.422l-1.25 1.25a.833.833 0 0 1-1.18-1.178l1.25-1.25a.833.833 0 0 1 .59-.244Zm10.833 0c.221 0 .433.088.59.244l1.25 1.25a.833.833 0 0 1-1.179 1.178l-1.25-1.25a.833.833 0 0 1 .59-1.422ZM9.167 5a4.167 4.167 0 1 1 0 8.334 4.167 4.167 0 0 1 0-8.334Zm-7.5 3.333a.833.833 0 0 1 0 1.667H.833a.833.833 0 1 1 0-1.667h.834Zm15.833 0a.833.833 0 0 1 0 1.667h-.833a.833.833 0 0 1 0-1.667h.833Zm-1.667-6.666a.833.833 0 0 1 .59 1.422l-1.25 1.25a.833.833 0 1 1-1.179-1.178l1.25-1.25a.833.833 0 0 1 .59-.244Zm-13.333 0c.221 0 .433.088.59.244l1.25 1.25a.833.833 0 0 1-1.18 1.178L1.91 3.09a.833.833 0 0 1 .59-1.422ZM9.167 0A.833.833 0 0 1 10 .833v.834a.833.833 0 1 1-1.667 0V.833A.833.833 0 0 1 9.167 0Z"
                fill="var(--text-primary)"
              />
            </svg>
            <label className="inline-flex items-center cursor-pointer">
              <input
                onClick={(e) => {
                  setColor(!color);
                  setTheme(!e.target.checked);
                  localStorage.setItem("themeCurrent", !color);
                }}
                checked={!color}
                type="checkbox"
                className="sr-only peer"
              />
              <div className="relative w-11 h-6 bg-btn focus:outline-none focus:border-0 peer-focus:outline-none peer-focus:ring-4 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-tab"></div>
            </label>
            <svg
              onClick={() => {
                setColor(false);
                setTheme(false);
                localStorage.setItem("themeCurrent", false);
              }}
              width="16"
              height="16"
              xmlns="http://www.w3.org/2000/svg"
              className={`cursor-pointer ${color && "opacity-60"}`}
            >
              <path
                d="M6.474.682c.434-.11.718.406.481.78A6.067 6.067 0 0 0 6.01 4.72c0 3.418 2.827 6.187 6.314 6.187.89.002 1.77-.182 2.584-.54.408-.18.894.165.724.57-1.16 2.775-3.944 4.73-7.194 4.73-4.292 0-7.771-3.41-7.771-7.615 0-3.541 2.466-6.518 5.807-7.37Zm8.433.07c.442-.294.969.232.674.674l-.525.787a1.943 1.943 0 0 0 0 2.157l.525.788c.295.441-.232.968-.674.673l-.787-.525a1.943 1.943 0 0 0-2.157 0l-.786.525c-.442.295-.97-.232-.675-.673l.525-.788a1.943 1.943 0 0 0 0-2.157l-.525-.787c-.295-.442.232-.968.674-.673l.787.525a1.943 1.943 0 0 0 2.157 0Z"
                fill="var(--text-primary)"
              />
            </svg>
          </div>
          <button
            onClick={() => setAppear(true)}
            className="flex border-green-600 border rounded-full p-0.5 text-green-600 justify-center items-center gap-x-1"
          >
            <div className="animate-ping animate-duration-400">
              <GoDotFill size={10} />
            </div>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
